/* Pagination dots under every horizontal rail of cards.

   One dot per page, not per card: a page is one viewport-width of the
   rail, so a rail showing 2.3 cards of 7 gets three dots, and the dot
   that is lit is the page the rail has scrolled to. Tapping a dot scrolls
   there. A rail whose cards all fit draws no dots at all - there is
   nothing to move to.

   Which rails: .rail-scroll (the home and PLP card rails), the listing
   page's .clp-curation-rail and the PDP's .pdp-clip-row. Filter bars, tab
   strips and the sub-category circles are controls rather than content
   and are left alone; a rail can also opt out with data-no-dots.

   Not Build the Look's .build-look-skus: that row sits inside a card
   that is itself one slide of a rail with its own dots, so a look with
   one product too many drew a second set of dots inside its card and
   pushed its price and "Add all" button out of line with the cards
   beside it.

   Rails are rebuilt in place by other scripts (an answered quiz swaps a
   rail's cards; a tab opens a hidden rail), so each rail's dots are
   recounted when its children change, when a tab is shown, and on
   resize, rather than only once at load. */
(function () {
  'use strict';

  var SELECTOR = '.rail-scroll, .clp-curation-rail, .pdp-clip-row';
  var DOTS_CLASS = 'vro-rail-dots';

  function pagesOf(rail) {
    var w = rail.clientWidth;
    if (!w) return 1;
    /* Rounded, not ceiled: a rail that overhangs its last page by a few
       pixels of gap would otherwise draw a dot for a page holding
       nothing but that gap. */
    return Math.max(1, Math.round(rail.scrollWidth / w));
  }

  function currentPage(rail) {
    var w = rail.clientWidth;
    if (!w) return 0;
    var max = rail.scrollWidth - w;
    /* The last dot lights as soon as the rail is scrolled to its end,
       even where the final page is a fraction of a width. */
    if (max > 0 && rail.scrollLeft >= max - 2) return pagesOf(rail) - 1;
    return Math.min(pagesOf(rail) - 1, Math.round(rail.scrollLeft / w));
  }

  function dotsFor(rail) {
    /* A caller that lays the dots out itself (the shuffle row, assets/
       vro-shuffle.js) hands over its own element. */
    if (rail.__vroDotsEl && rail.__vroDotsEl.isConnected) return rail.__vroDotsEl;
    var next = rail.nextElementSibling;
    if (next && next.classList.contains(DOTS_CLASS)) return next;
    var el = document.createElement('div');
    el.className = DOTS_CLASS;
    el.setAttribute('role', 'tablist');
    el.setAttribute('aria-label', 'Scroll position');
    rail.parentNode.insertBefore(el, rail.nextSibling);
    return el;
  }

  function render(rail) {
    var dots = dotsFor(rail);
    var pages = pagesOf(rail);
    if (pages < 2 || rail.offsetParent === null) {
      dots.hidden = true;
      dots.innerHTML = '';
      return;
    }
    var cur = currentPage(rail);
    if (dots.childElementCount !== pages) {
      dots.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = DOTS_CLASS + '-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + pages);
        b.setAttribute('data-page', String(i));
        dots.appendChild(b);
      }
    }
    Array.prototype.forEach.call(dots.children, function (b, i) {
      var on = i === cur;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    dots.hidden = false;
  }

  function bind(rail) {
    if (rail.__vroDots) return;
    rail.__vroDots = true;
    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; render(rail); });
    }
    rail.addEventListener('scroll', schedule, { passive: true });
    dotsFor(rail).addEventListener('click', function (e) {
      var dot = e.target.closest('[data-page]');
      if (!dot) return;
      var page = parseInt(dot.getAttribute('data-page'), 10) || 0;
      var left = Math.min(page * rail.clientWidth, rail.scrollWidth - rail.clientWidth);
      try { rail.scrollTo({ left: left, behavior: 'smooth' }); } catch (err) { rail.scrollLeft = left; }
    });
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(rail, { childList: true });
    }
    if (window.ResizeObserver) {
      new ResizeObserver(schedule).observe(rail);
    }
    render(rail);
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(SELECTOR), function (rail) {
      if (rail.hasAttribute('data-no-dots')) return;
      bind(rail);
    });
  }

  function refreshAll() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (rail) {
      if (rail.__vroDots) render(rail);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', refreshAll);
  window.addEventListener('resize', refreshAll);
  /* A rail inside a closed Bootstrap tab has no width until the tab is
     shown; recount when one is. The event bubbles from the tab trigger. */
  document.addEventListener('shown.bs.tab', function () { setTimeout(refreshAll, 50); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.VroRailDots = { init: init, refresh: refreshAll };
})();
